module.exports = __webpack_public_path__ + "img/author.92ca2d6c.jpg";